module.exports = __webpack_public_path__ + "static/media/8.fdf59c9a.png";